import type { ModuleProperties } from '@/lib/core/types';
import { UmbracoForm } from '@/components/forms/umbracoForm';

interface FormBlockProperties {
  formTitle?: string | null;
  form?: Record<string, unknown> | null;
}

export const FormBlock = (props: ModuleProperties) => {
  const content = props.content?.properties as FormBlockProperties | undefined;
  const contentId = props.context?.page?.id;

  if (!content?.form) return null;

  // The Umbraco form picker value includes the form GUID at key "id".
  const formId = content.form['id'] as string | undefined;

  if (!formId) return null;

  const instanceId = import.meta.env.VITE_CMS_INSTANCE_ID ?? 'default';

  return (
    <UmbracoForm
      instanceId={instanceId}
      formId={formId}
      contentId={contentId}
      className="mx-auto w-full max-w-lg"
    />
  );
};
